export default __webpack_public_path__ + "static/media/NC_game_paths-preview.34e29d4f.png";